import { FC, useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme, Badge, Chip } from '@mui/material';

const PolicyOption: FC<React.PropsWithChildren<PolicyOptionProps>> = props => {
  const { classes } = useStyles();
  const { name, appsCount, id, onOptionClick } = props;
  const onOptionClickCall = useCallback(() => {
    onOptionClick(id);
  }, [id, onOptionClick]);
  const chip = (
    <Chip
      size='small'
      label={name}
      variant={appsCount ? 'outlined' : 'filled'}
      onClick={onOptionClickCall}
      className={classes.innerOption}
    />
  );
  return appsCount ? (
    <Badge badgeContent={appsCount} color='primary' showZero={true} max={10000}>
      {chip}
    </Badge>
  ) : (
    chip
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  option: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  innerOption: {
    padding: theme.spacing(0.5),
    cursor: 'pointer',
  },
}));

export interface PolicyOptionProps {
  id: string;
  name: string;
  appsCount: number;
  selected?: boolean;
  onOptionClick: (optionId: string) => void;
}

export default PolicyOption;
